<template lang="html">
  <div class="wardrobe-container" v-if="currentWardrobe">
    <CreateOutfitWrapper />

    <div class="notification-click-products" v-if="builderMode">
      <span>👇</span>
      <span class="notification-click-products-text">
        <strong>Click</strong> products <strong>below</strong> to add to outfit
      </span>
      <span>👇</span>
    </div>

    <div v-if="!productsLoaded">
      <div v-for="group in groups" class="group-container">
        <div class="group-title">{{ group.name }}</div>
        <div class="group-items">
          <LoadingProducts />
        </div>
      </div>
    </div>

    <div v-else-if="productsLoaded && hasProducts">
      <div
        v-for="(group, index) in groups"
        class="group-container"
        v-if="showProducts(group.slug)"
      >
        <div class="group-title" :ref="group.slug">
          {{ group.name }}
        </div>
        <div class="product-group-container-wrapper">
          <div class="product-group-container">
            <component
              v-for="wp in wardrobeProductsByGroup(group.slug)"
              :key="wp.id"
              :wardrobe-product="wp"
              :is="productComponentType(wp)"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <WardrobeEmptyState />
    </div>
  </div>
</template>

<script>
import CreateOutfitWrapper from "@/components/wardrobe/clothes/CreateOutfitWrapper";
import LoadingProducts from "@/components/wardrobe/LoadingProducts";
import Product from "@/components/wardrobe/clothes/Product";
import ProductEmpty from "@/components/wardrobe/clothes/ProductEmpty";
import WardrobeEmptyState from "@/components/wardrobe/WardrobeEmptyState";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    CreateOutfitWrapper,
    LoadingProducts,
    Product,
    ProductEmpty,
    WardrobeEmptyState
  },

  mounted() {
    window.analytics.page("Wardrobe Clothes");

    if (!this.wardrobeDataStates.products.fetching && !this.productsLoaded) {
      this.fetchWardrobeProducts(this.currentUser.wardrobe_id).then(() => {
        if (
          !this.wardrobeDataStates.outfits.fetching &&
          !this.wardrobeDataStates.outfits.loaded
        )
          this.fetchWardrobeOutfits(this.currentUser.wardrobe_id);
      });
    }
  },

  data() {
    return {
      groups: this.$constants.LAYER_GROUPS
    };
  },

  computed: {
    ...mapGetters({
      builderMode: "wardrobeBuilderMode",
      currentUser: "currentUser",
      currentWardrobe: "currentWardrobe",
      wardrobeDataStates: "wardrobeDataStates",
      wardrobeProducts: "wardrobeProducts",
      pendingProducts: "wardrobeProductIdsPending"
    }),

    productsLoaded() {
      return this.wardrobeDataStates.products.loaded;
    },

    hasProducts() {
      return this.currentWardrobe
        ? this.currentWardrobe.wardrobe_products_count > 0
        : false;
    }
  },

  methods: {
    ...mapActions([
      "fetchWardrobeOutfits",
      "fetchWardrobeProducts",
      "pollPendingWardrobeProducts"
    ]),

    pollData() {
      this.pollPendingWardrobeProducts(this.currentUser.wardrobe_id).then(
        () => {
          if (this.pendingProducts.length > 0) {
            setTimeout(() => this.pollData(), 3000);
          }
        }
      );
    },

    productComponentType(wardrobeProduct) {
      return wardrobeProduct.product ? "Product" : "ProductEmpty";
    },

    showProducts(groupName) {
      return (
        this.wardrobeProducts &&
        this.wardrobeProductsByGroup(groupName).length > 0
      );
    },

    wardrobeProductsByGroup(groupName) {
      return this.wardrobeProducts.filter(product => {
        return product.group === groupName;
      });
    }
  },

  watch: {
    hasPendingProducts: function(newVal, oldVal) {
      if (newVal === true) this.pollData();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";

.wardrobe-container {
  .wardrobe-header {
    display: flex;
    justify-content: space-between;
  }
}

.group-title {
  background-color: #f6f6f6;
  color: $grey1;
  letter-spacing: 1px;
  padding: 10px 15px;
  text-transform: capitalize;
  width: 100%;
  margin-top: 80px;
  margin-bottom: 50px;
}

.group-items {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 0 auto;
  width: 100%;
}

.product-group-container-wrapper {
  overflow-x: hidden;
}

.product-group-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-left: -1rem;
}

.notification-click-products {
  text-align: center;

  .notification-click-products-text {
    margin-left: 30px;
    margin-right: 30px;
    font-size: 1.1rem;
    color: $grey1;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Users/Wardrobe/WardrobeClothes.vue